export const DateFormats = {
  ShortDateFormatHyphen: {
    type: "dateTime",
    format: "MM-dd-yyyy",
    momentJsFormat: "MM-DD-yyyy",
    momentJsFormatInverted: "yyyy-MM-DD",
    momentJsFormat_Shorter: "MM-DD",
  },
  ShortDateFormat: {
    type: "dateTime",
    format: "MM/dd/yyyy",
    momentJsFormat: "MM/DD/yyyy",
    momentJsFormat_Shorter: "MM/DD",
  },
  ShortDateTimeFormat: {
    type: "dateTime",
    format: "MM/dd/yyyy hh:mm a",
    momentJsFormat: "MM/DD/yyyy hh:mm a",
    momentJsFormatUpperA: "MM/DD/yyyy hh:mm A",
  },
  ShortDateTimeFormatHyphen: {
    type: "dateTime",
    format: "MM-dd-yyyy hh:mm a",
    momentJsFormat: "MM-DD-yyyy hh-mm-ssa",
  },
  ShortDateVerboseFormat: {
    type: "dateTime",
    format: "MMM d, yyyy",
    momentJsFormat: "ll",
  },
  ShortDateTimeVerboseFormat: {
    type: "dateTime",
    format: "MMM d, yyyy hh:mm a",
    momentJsFormat: "MMM DD yyyy, hh:mm A",
  },
  LongDateFormat: {
    type: "dateTime",
    format: "MMMM d, yyyy",
    momentJsFormat: "MMMM DD, yyyy",
  },
  LongDateTimeFormat: {
    type: "dateTime",
    format: "MMMM d, yyyy hh:mm a",
    momentJsFormat: "MMMM DD, yyyy hh:mm a",
  },
  TimeFormat: {
    type: "dateTime",
    format: "hh:mm a",
    momentJsFormat: "hh:mm a",
  },
  MonthDay: {
    type: "dateTime",
    momentJsFormat: "MMM DD",
  },
  MomentCalendarFormat: {
    sameDay: "[Today]",
    lastDay: "MMMM DD, YYYY",
    lastWeek: "MMMM DD, YYYY",
    sameElse: "MMMM DD, YYYY",
  },
  MomentDescriptiveDateAndTimeFormat: {
    type: "dateTime",
    momentJsFormat: "ddd, MMM DD, YYYY h:mm A",
    momentJsFormat_en: "MMMM DD, YYYY [at] h:mm A",
    momentJsFormat_es: "MMMM DD, YYYY [a las] h:mm A",
    momentJsDayFormat_en: "dddd, M/D/YYYY [at] h:mm A",
    momentJsDayFormat_es: "dddd, D/M/YYYY [a las] h:mm A",
  },
};
